import { FC } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  PopoverCloseButton,
  PopoverArrow,
  PopoverContent,
  Portal,
  PopoverTrigger,
  Popover,
  Flex,
  Button,
  PopoverBody,
} from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../consts/routes';
import { CardDeck, OlaggModule, PermissionEnum } from '@olagg/db-types';
import { useAdminCardDecks } from '@olagg/api-hooks';
import useRoles from '../../features/Roles/hooks/useRoles';

interface CardDeckTableProps {
  cardDecks: CardDeck[];
  onUpdate: () => void;
}

const CardDeckTable: FC<CardDeckTableProps> = ({ cardDecks, onUpdate }) => {
  const navigate = useNavigate();
  const { deleteCardDeck } = useAdminCardDecks();
  const { missingPermission } = useRoles();

  const editCardDeck = (id: string | number) => navigate(generatePath(ROUTES.CARD_DECKS.update, { id }))

  return (
    <Table
      variant="striped"
      colorScheme="olaggPurple"
      fontSize="18px"
      position='relative'
    >
      <Thead>
        <Tr>
          <Th>Id</Th>
          <Th>Nombre</Th>
          <Th>Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {cardDecks.map((deck) => (
          <Tr key={deck.id}>
            <Td>{deck.id}</Td>
            <Td>{deck.name}</Td>
            <Td>
              <Flex gap='3' alignItems='center'>
                <Button
                  size={'sm'} padding='17px 14px'
                  variant="outlinedGradient"
                  onClick={() => navigate(generatePath(ROUTES.CARD_DECKS.servers.all, { deck_id: deck.id }))}
                >
                  Discord Servers
                </Button>
                <Button
                  size={'sm'} padding='17px 14px'
                  variant="outlinedGradient"
                  onClick={() => navigate(generatePath(ROUTES.CARD_DECKS.traits.all, { deck_id: deck.id }))}
                >
                  Traits
                </Button>

                <Button size={'sm'} padding='14px 16px' colorScheme='green'
                  onClick={(e) => { e.stopPropagation(); editCardDeck(deck.id); }}
                  leftIcon={<FaEdit />}
                  isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.EDIT)}
                  >
                  Editar
                </Button>
                      
                <Popover>
                  <PopoverTrigger>
                    <Button
                      size={'sm'} padding='14px 16px' ml={0} colorScheme="red"
                      onClick={(e) => e.stopPropagation()}
                      leftIcon={<FaTrash />}
                      isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.DELETE)}
                    >
                      Eliminar
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverBody>
                        <Button width={'100%'} colorScheme='red'
                          onClick={async (e) => { e.stopPropagation(); await deleteCardDeck(Number(deck.id)); onUpdate(); }}
                        >
                          Confirmar Eliminar
                        </Button>
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </Flex>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default CardDeckTable; 